module.exports = __webpack_public_path__ + "img/MS_WeaponSword004.e58860e3.png";